import { Abstrap } from '../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'button' };

class AdvertButton extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-advert__btn',
            className,
        ];
    }

}

AdvertButton.propTypes = propTypes;

AdvertButton.defaultProps = defaultProps;

export default AdvertButton;
